import { cx } from '@linaria/core';
import {
	type ReactNode,
	useCallback,
	useEffect,
	useRef,
	useState,
} from 'react';

import { getRandomInt } from '~utils/numbers';

import {
	Card,
	Progress,
	ProgressItem,
	StyledQuotesCarousel,
	Wrapper,
} from './styles';

export const QuotesCarousel = ({
	children,
	timeout = 3000,
	className,
}: {
	children: ReactNode[];
	timeout?: number;
	className?: string;
}) => {
	const [currentQuote, setCurrentQuote] = useState(
		getRandomInt(0, children.length - 1)
	);

	const ref = useRef<NodeJS.Timeout | null>(null);

	const handleChangeCurrentQuote = useCallback(() => {
		setCurrentQuote((prev) => {
			if (prev === children.length - 1) {
				return 0;
			}
			return prev + 1;
		});
	}, [children.length]);

	useEffect(() => {
		ref.current = setInterval(handleChangeCurrentQuote, timeout);

		return () => {
			if (ref.current) {
				clearInterval(ref.current);
			}
		};
	}, [handleChangeCurrentQuote, timeout]);

	return (
		<StyledQuotesCarousel className={className}>
			<Wrapper
				style={{
					transform: `translateX(calc(-${currentQuote * 100}% - ${
						2 * currentQuote
					}rem))`,
				}}
			>
				{children.map((child, index) => (
					<Card key={index}>{child}</Card>
				))}
			</Wrapper>
			<Progress>
				{Array.from({ length: children.length }).map((_, index) => (
					<ProgressItem
						timeout={timeout}
						className={cx(index === currentQuote && 'active')}
						key={index}
					>
						<div />
					</ProgressItem>
				))}
			</Progress>
		</StyledQuotesCarousel>
	);
};
